import { render, staticRenderFns } from "./ListShippingSubscriptionComponent.vue?vue&type=template&id=622354fe&scoped=true&"
import script from "./ListShippingSubscriptionComponent.vue?vue&type=script&lang=js&"
export * from "./ListShippingSubscriptionComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622354fe",
  null
  
)

export default component.exports